export enum ImageSizes {
  Raw = "RAW",
  Small = 100,
  Medium = 200,
  Large = 400,
}
